import { render } from "./RefreshComponent.vue?vue&type=template&id=0045cd0b&scoped=true"
import script from "./RefreshComponent.vue?vue&type=script&lang=js"
export * from "./RefreshComponent.vue?vue&type=script&lang=js"

import "./RefreshComponent.vue?vue&type=style&index=0&id=0045cd0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0045cd0b"]])

export default __exports__